<template>
    <div class="hover-map" ref="map" />
</template>

<script>
    const google = window.google

    export default {
        props: [
            'value'
        ],

        data() {
            return {
                coordinates: null,
                map: null,
                infoWindow: null,
                loading: false,
                dialog: false,
                editedItem: null,
                display: null,
                isClicked: false,
                refreshKey: 0
            };
        },

        mounted() {
            this.load();
        },

        methods: {
            load() {
                var startCoordinates = new google.maps.LatLng(this.round(this.value.latitude, 4), this.round(this.value.longitude, 4));

                var options = {
                    zoom: 11,
                    center: startCoordinates,
                    disableDefaultUI: true,
                    gestureHandling: 'greedy',
                    clickableIcons: false
                };

                var div = this.$refs.map;
                this.map = new google.maps.Map(div, options);

                var content = this.displayCoordinates(this.value.latitude, this.value.longitude);
                this.infoWindow = new google.maps.InfoWindow(
                    { content: content, position: startCoordinates });
                this.infoWindow.open(this.map);
            },
            round(number, decimalPlaces) {
                return Math.round((number + Number.EPSILON) * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces)
            },
            displayCoordinates(lat, lng) {
                return this.round(lat, 4) + ", " + this.round(lng, 4);
            },
        },
        watch: {
            value() {
                this.load();
            },
        }
    };
</script>

<style>
    .hover-map {
        width: 100%;
        height: 400px;
    }
</style>
